export default "__VITE_ASSET__$sIIwG4m__"